(function() { window.GUID_5f47010f_f933_44bc_9988_fc7bc0cb3366 = { getGuid: function() { return "5f47010f-f933-44bc-9988-fc7bc0cb3366"; } }; })();
var CS;
(function (CS) {
    var DataRange;
    (function (DataRange) {
        class ReadOnlyDataRange {
            constructor(data) {
                this.data = data;
            }
            get minValue() { return this.data.minValue; }
            get maxValue() { return this.data.maxValue; }
        }
        DataRange.ReadOnlyDataRange = ReadOnlyDataRange;
        /** this class expose an readonly IDataRange instance. It assure the instance will not get replaced with a new instance. */
        class ReadOnlyDataRangePropertyHelper {
            constructor(data) {
                this.data = data;
                if (data)
                    this.dateRange = data;
                else
                    this.dateRange = { maxValue: null, minValue: null };
                this.dateRangeInstance = new ReadOnlyDataRange(this.dateRange);
            }
            get DataRangeReadOnly() { return this.dateRangeInstance; }
            SetData(data) {
                this.dateRange.maxValue = data.maxValue;
                this.dateRange.minValue = data.minValue;
                this.valueChange("all");
            }
            get minValue() { return this.dateRange.minValue; }
            set minValue(value) { this.dateRange.minValue = value; this.valueChange("minValue"); }
            get maxValue() { return this.dateRange.maxValue; }
            set maxValue(value) { this.dateRange.maxValue = value; this.valueChange("maxValue"); }
            valueChange(valueName) {
                if (this.ValueChangedCallback)
                    this.ValueChangedCallback(valueName);
            }
        }
        DataRange.ReadOnlyDataRangePropertyHelper = ReadOnlyDataRangePropertyHelper;
    })(DataRange = CS.DataRange || (CS.DataRange = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-data-range.js.map
